import {RichTextLinkBlockConstants} from '../../adapters/helpers/Constants';
import Block from '../../adapters/helpers/Block';
import dynamic from 'next/dynamic';
import React,{Suspense} from 'react'
import PropTypes from 'prop-types'
const Image = dynamic(() => import('../Image/Image'));
import Link from 'next/link';
import Loader from '../../adapters/helpers/Loader';

function RichTextLink(props) {
    const block = new Block(props);
    const image = block.getFieldValue(RichTextLinkBlockConstants.image);
    const linkType = block.getFieldValue(RichTextLinkBlockConstants.linkType);
    const title = block.getFieldValue(RichTextLinkBlockConstants.title);
    const isPDF = block.getFieldValue(RichTextLinkBlockConstants.isPdfLink);
    const url = isPDF ? block.getFieldValue(RichTextLinkBlockConstants.asset)?.fields?.file?.url  : block.getFieldValue(RichTextLinkBlockConstants.url) 

    return (
        <div className={'ob-rich-text-link'}>
             <Suspense fallback={<Loader />}>
                <Link href={url}
                    target={linkType === 'external' ? '_blank' : null }
                    rel={linkType === 'external' ? 'noopener noreferrer' : ''}
                >
                {image ? <Image image={image} /> : <>{title}</>}
                </Link>
            </Suspense>
        </div>
    )
}

RichTextLink.propTypes = {
    /**
    * The Link type (external, internal, social)
    */
    linkType: PropTypes.string,

    /**
     * Image used in the link
     */
    image: PropTypes.object,
    
    /**
     * The url the link points to
     */
    url: PropTypes.string,
}

export default RichTextLink;

